function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.25 0.25)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53,60H7a7.008,7.008,0,0,1-7-7V7A7.007,7.007,0,0,1,7,0H53a7.007,7.007,0,0,1,7,7V53A7.008,7.008,0,0,1,53,60ZM2,16.043V53a5.005,5.005,0,0,0,5,5H53a5.005,5.005,0,0,0,5-5V16.043ZM7,2A5,5,0,0,0,2,7v7.045H58V7a5,5,0,0,0-5-5Z",
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.019,2.027a1.087,1.087,0,0,0,.733-.306,1.018,1.018,0,0,0,.285-.713A1.067,1.067,0,0,0,1.752.275a1.088,1.088,0,0,0-1.446,0A1.048,1.048,0,0,0,0,1.008,1.044,1.044,0,0,0,1.019,2.027",
  transform: "translate(17.894 8.163)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.019,2.032a1.128,1.128,0,0,0,.733-.306,1.077,1.077,0,0,0,.306-.713A1.128,1.128,0,0,0,1.752.28,1.04,1.04,0,0,0,0,1.014a1.043,1.043,0,0,0,.326.733,1.006,1.006,0,0,0,.693.285",
  transform: "translate(39.964 8.158)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.933.064.667,2.01a1.018,1.018,0,1,0,.7,1.911l3.9-1.438V23.721a1.019,1.019,0,1,0,2.037,0V1.02A1.019,1.019,0,0,0,6.868.184a1.008,1.008,0,0,0-.935-.12",
  transform: "translate(34.741 24.982)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.524,10.537l7.234-8.874A1.019,1.019,0,0,0,14.968,0H1.807a1.019,1.019,0,1,0,0,2.037H12.823l-7.2,8.829a1.016,1.016,0,0,0-.112,1.116,1,1,0,0,0,.98.542c1.22-.09,4.763.051,6.472,1.842a4.338,4.338,0,0,1,.99,3.751A4.384,4.384,0,0,1,10.109,22.1c-3.1.583-7.008-.878-8.2-3.07A1.019,1.019,0,0,0,.123,20c1.371,2.532,5.01,4.268,8.528,4.268a9.988,9.988,0,0,0,1.836-.167,6.4,6.4,0,0,0,5.492-5.733,6.316,6.316,0,0,0-1.538-5.409,9.43,9.43,0,0,0-5.916-2.424",
  transform: "translate(14.777 25.725)",
  fill: "#fff"
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.cf8c1df8.svg";
export { ForwardRef as ReactComponent };